import React, {Component} from 'react';
import {Row, Col, ControlLabel, Form, FormGroup, ButtonToolbar, FormControl, Checkbox} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../shared/validatorMessages/ValidatorMessages";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import LogowanieService from "../../../logowanie/LogowanieService";
import Select from 'react-select'
import KlienciService from "../../../klienciConfig/KlienciService";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import Validator from "../../../../utilities/Validator";

export default class DostepForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imie: '',
            nazwisko: '',
            email: '',
            login: '',
            haslo: '',
            czyZablokowany: {value: false, label: 'nie'},
            role: [],
            validatorMessages: [],
            zablokowanyOptions: [{value: false, label: 'nie'}, {value: true, label: 'tak'}],
            czyHasloOk: false,
            typykont: [{value: 1, label: 'KLIENT', controlLabel: 'Klient'}, {value: 2, label: 'KIEROWCA', controlLabel: 'Kierowca'}, {
                value: 3,
                label: 'PRACOWNIK',
                controlLabel: 'Pracownik'
            }],
            typkonta: null,
            konto: null,
            edytowanyUser:null,

        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeLogin = this.onChangeLogin.bind(this)
        this.onChangeHaslo = this.onChangeHaslo.bind(this)
        this.onChangeRole = this.onChangeRole.bind(this)
        this.onChangeZablokowany = this.onChangeZablokowany.bind(this)
        this.onChangeTypKonta = this.onChangeTypKonta.bind(this)
        this.onChangeKonto = this.onChangeKonto.bind(this)
    }

    componentDidMount() {

        if (Boolean(this.props.user)) {
            this.setState({
                login: this.props.user.login,
                haslo: this.props.user.pass,
                role: this.props.user.role,
                czyZablokowany: Boolean(this.props.user.zablokowany) ? {value: true, label: 'tak'} : {value: false, label: 'nie'},
                edytowanyUser:this.props.user
            })

            document.getElementById('inputLogin').value = this.props.user.login

            setTimeout(function () {
                if (this.props.user.typ !== 'KLIENT' && this.props.user.typ !== 'KIEROWCA') {
                    this.props.user.role.forEach(item => {
                        document.getElementById('CB_' + item.rola).checked = true
                    })
                }
            }.bind(this), 500)

        } else this.setState({typkonta: this.state.typykont[0]})
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.user)) {

            this.setState({
                login: nextprops.user.login,
                haslo: nextprops.user.pass,
                role: nextprops.user.role,
                czyZablokowany: Boolean(nextprops.user.zablokowany) ? {value: false, label: 'nie'} : {value: true, label: 'tak'},
                edytowanyUser:nextprops.user
            })

            document.getElementById('inputLogin').value = nextprops.user.login


            setTimeout(function () {
                if (nextprops.user.typ !== 'KLIENT' && nextprops.user.typ !== 'KIEROWCA') {
                    nextprops.user.role.forEach(item => {
                        document.getElementById('CB_' + item.rola).checked = true
                    })
                }
            }.bind(this), 500)
        }
    }

    onChangeLogin(e) {
        if(Validator.validateLenghtWithClearing(e.target.value,100,'inputLogin',this.state.login))
        this.setState({login: e.target.value})
    }

    onChangeHaslo(e) {
        this.setState({haslo: e.target.value})
        if (e.target.value.length >= 8 && e.target.value.length <= 20 && Boolean(Validator.czyZawieraDuzaLitere(e.target.value) && Boolean(Validator.czyZawieraCyfreLubZnakSpecjalny(e.target.value)))) {
            this.setState({czyHasloOk: true})
        } else this.setState({czyHasloOk: false})
    }

    onChangeZablokowany(e) {
        this.setState({czyZablokowany: e})
    }

    onChangeTypKonta(e) {
        this.setState({typkonta: e, konto: null})
    }

    onChangeKonto(e) {
        this.setState({konto: e})
    }

    onChangeRole() {

        let checkboxes = document.querySelectorAll("input[type='checkbox']")

        for (let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].disabled = false
        }


        if (document.getElementById('CB_ROLE_ADMIN').checked) {
            for (let i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].id !== 'CB_ROLE_ADMIN'  && checkboxes[i].id !== 'CB_ROLE_SITE_ADMIN') {
                    checkboxes[i].disabled = true
                    checkboxes[i].checked = false
                }
            }
        }

        if (document.getElementById('CB_ROLE_URZAD').checked) {
            for (let i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].id !== 'CB_ROLE_URZAD') {
                    checkboxes[i].disabled = true
                    checkboxes[i].checked = false
                }
            }
        }

        else if (document.getElementById('CB_ROLE_OPERATOR').checked) {
            document.getElementById('CB_ROLE_ADMIN').disabled = true
            document.getElementById('CB_ROLE_ADMIN').checked = false
            document.getElementById('CB_ROLE_URZAD').disabled = true
            document.getElementById('CB_ROLE_URZAD').checked = false
        }


        if (Boolean(this.props.user)) {
            let arr = this.state.role

            for (let i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked && !this.state.role.find(r => r.rola === checkboxes[i].value)) {
                    arr.push({rola: checkboxes[i].value})
                }
                else if (!checkboxes[i].checked && this.state.role.find(r => r.rola === checkboxes[i].value)) {
                    if (arr.findIndex(r => r.rola == checkboxes[i].value) > -1) {
                        arr.splice(arr.findIndex(r => r.rola == checkboxes[i].value), 1)
                    }
                }
            }
            this.setState({role: arr})
        }
        else {
            let arr = []
            for (let i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked) {
                    arr.push({rola: checkboxes[i].value})
                }
            }
            this.setState({role: arr})
        }
    }

    onClickZapisz() {
        let poprawne = true;
        this.state.validatorMessages = [];

        if (this.state.login.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Pole login jest wymagane')
        }
        if (this.state.haslo.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Pole haslo jest wymagane')
        }
        if (!this.state.czyHasloOk && !Boolean(this.props.user)) {// gdy jest dodawanie
            poprawne = false;
            this.dodajDoValidatorMessages('Pole haslo nie spełnia kryteriów')
        }
        if(!Boolean(this.props.user)){
            // tylko przy dodawaniu

            if (this.state.typkonta.label !== 'KLIENT' && this.state.typkonta.label !== 'KIEROWCA') {
                if (this.state.role.length <= 0) {
                    poprawne = false;
                    this.dodajDoValidatorMessages('Proszę wybrać co najmniej jedną rolę')
                }
            }
            if (!this.state.konto) {
                poprawne = false;
                this.dodajDoValidatorMessages('Konto musi być przypisane')
            }
        }


        if (poprawne) {
            this.setState({validatorMessages: []})

            if (Boolean(this.props.user)) {
                // edycja

                let usr = this.state.edytowanyUser
                usr['pass'] = null;
                usr['zablokowany'] = this.state.czyZablokowany.value
                usr['zmienilUzytk'] = LogowanieService.pobierzLoginZalogowanego()
                usr['dataZmiany'] = new Date().toJSON()
                usr['role']= (this.state.edytowanyUser.typ === 'PRACOWNIK') ? this.state.role : this.props.user.role


                this.props.handleZapisz(usr, Boolean(this.props.user))
            }
            else {
                // dodawanie
                let data = {
                    login: this.state.login,
                    pass: this.state.haslo,
                    role: Boolean(this.state.typkonta.label === 'KLIENT') ? [{rola: 'ROLE_KLIENT'}] : Boolean(this.state.typkonta.label === 'KIEROWCA') ? [{rola: 'ROLE_KIEROWCA'}] : this.state.role,
                    dodalUzytk: LogowanieService.pobierzLoginZalogowanego(),
                    zablokowany: this.state.czyZablokowany.value,
                    zmienilUzytk: null,
                    typ: this.state.typkonta.label,
                    typId: this.state.konto.typId,
                }
                this.props.handleZapisz(data, Boolean(this.props.user))
            }


        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }



    getUsers(input){
        if(!input){
            return Promise.resolve({options:[]})
        }

        return  KlienciService.getKlienciBezZdjec(input).then(function (response) {

            let arr = Array.from(response.data.content,item=>{
                return{
                    ...item,
                    info:item.imie+' '+item.nazwisko+" "+item.nrTel+' '+item.email+" "+item.pesel,
                    typId:item.idKl
                }
            })
            return { options: arr }
        }.bind(this))
    }

    render() {
        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.user) ? 'Edycja dostępu' : 'Nowy dostęp'}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} lg={6}>
                                <Row>
                                    <TopIf isTrue={!Boolean(this.props.user)}>
                                    <Col xs={12} lg={6}>
                                        <ControlLabel>
                                            Typ konta <span style={{color: 'red'}}>*</span>
                                        </ControlLabel>
                                        <TopSelect onChange={this.onChangeTypKonta} value={this.state.typkonta} options={this.state.typykont}
                                                   clearable={false}/>
                                    </Col>
                                    </TopIf>
                                    <TopIf isTrue={!Boolean(this.props.user)}>
                                    <Col xs={12} lg={6}>
                                        {
                                            Boolean(this.state.typkonta) ?
                                                <div>
                                                    <ControlLabel>
                                                        {this.state.typkonta.controlLabel} <span style={{color: 'red'}}>*</span>
                                                    </ControlLabel>
                                                    {// gdy klient
                                                        Boolean(this.state.typkonta.value === 1) ?


                                                            <Select.Async value={this.state.konto} onChange={this.onChangeKonto} valueKey="idKl"
                                                                            labelKey="info" loadOptions={this.getUsers}
                                                                            backspaceRemoves={true}
                                                                          ignoreAccents={false}
                                                                            placeholder={'Szukaj po nazwisku, pesel, email'}
                                                            />


                                                            :   //kierowca
                                                            Boolean(this.state.typkonta.value === 2) ?
                                                                <TopSelect onChange={this.onChangeKonto} value={this.state.konto}
                                                                           options={this.props.kierowcy} valueKey={'idKi'} labelKey={'info'}
                                                                           placeholder={'Szukaj po: imie, nazwisko, pesel'}/>
                                                                :   //pracownik
                                                                <TopSelect onChange={this.onChangeKonto} value={this.state.konto}
                                                                           options={this.props.pracownicy} valueKey={'idPr'} labelKey={'info'}
                                                                           placeholder={'Szukaj po: imie, nazwisko, email'}/>
                                                    }
                                                </div>
                                                :
                                                ''
                                        }
                                    </Col>
                                    </TopIf>
                                </Row>
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <ControlLabel>
                                            Login <span style={{color: 'red'}}>*</span>
                                        </ControlLabel>
                                        <FormControl onChange={this.onChangeLogin} id={'inputLogin'} disabled={Boolean(this.props.user)}/>
                                    </Col>
                                    {
                                        Boolean(this.props.user) ?
                                            ''
                                            :
                                            <Col xs={12} lg={6}>
                                                <ControlLabel>
                                                    Hasło <span style={{color: 'red'}}>*</span> <span
                                                    style={{fontWeight: 'normal', fontSize: '12px'}}>Znaków: {this.state.haslo.length}</span>
                                                </ControlLabel>
                                                <FormControl type={'password'} onChange={this.onChangeHaslo} id={'inputHaslo'}/>
                                            </Col>

                                    }
                                </Row>
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <ControlLabel>
                                            Czy zablokowany?
                                        </ControlLabel>
                                        <TopSelect onChange={this.onChangeZablokowany}
                                                   value={this.state.czyZablokowany}
                                                   options={this.state.zablokowanyOptions}
                                                   clearable={false}
                                        />
                                    </Col>
                                    {
                                        Boolean(this.props.user) ?
                                            ''
                                            :

                                            <Col xs={12} lg={6}>
                                                <div id={'zmianaHaslaHelp'}>
                                                    <div>
                                                        <label>Ilość znaków w haśle zawiera się w
                                                            8-20? </label> {Boolean(this.state.haslo.length >= 8 && this.state.haslo.length <= 20) ?
                                                        <i className="fa fa-check-circle"></i> : <i className="fa fa-times-circle"></i>}
                                                    </div>
                                                    <div>
                                                        <label>Czy hasło zawiera dużą
                                                            literę? </label> {Boolean(Validator.czyZawieraDuzaLitere(this.state.haslo)) ?
                                                        <i className="fa fa-check-circle"></i> : <i className="fa fa-times-circle"></i>}
                                                    </div>
                                                    <div>
                                                        <label>Czy hasło zawiera liczbę lub
                                                            znak? </label> {Boolean(Validator.czyZawieraCyfreLubZnakSpecjalny(this.state.haslo)) ?
                                                        <i className="fa fa-check-circle"></i> : <i className="fa fa-times-circle"></i>}
                                                    </div>
                                                </div>

                                            </Col>
                                    }
                                </Row>
                            </Col>
                            {
                                Boolean(this.state.typkonta) ?
                                    Boolean(this.state.typkonta.label !== 'KLIENT' && this.state.typkonta.label !== 'KIEROWCA') ?
                                        <Col xs={12} lg={6}>
                                            <div>
                                                {
                                                    this.props.role.map(item => {
                                                        if (item.uzytk_rola !== 'ROLE_KLIENT' && item.uzytk_rola !== 'ROLE_KIEROWCA') {

                                                            return <Checkbox inline={false} onChange={this.onChangeRole} value={item.uzytk_rola}
                                                                             id={'CB_' + item.uzytk_rola}>
                                                                <span className={'label label-ebus-primary'}>{item.uzytk_rola}</span>
                                                                <span style={{marginLeft: '5px', fontSize: '12px'}}>{item.opis}</span>
                                                            </Checkbox>
                                                        }
                                                    })
                                                }
                                            </div>
                                        </Col>
                                        :
                                        '' : ''
                            }
                            {
                                Boolean(this.state.edytowanyUser) ?
                                    Boolean(this.state.edytowanyUser.typ !== 'KLIENT' && this.state.edytowanyUser.typ !== 'KIEROWCA') ?
                                        <Col xs={12} lg={6}>
                                            <div>
                                                {
                                                    this.props.role.map(item => {
                                                        if (item.uzytk_rola !== 'ROLE_KLIENT' && item.uzytk_rola !== 'ROLE_KIEROWCA') {

                                                            return <Checkbox inline={false} onChange={this.onChangeRole} value={item.uzytk_rola}
                                                                             id={'CB_' + item.uzytk_rola}>
                                                                <span className={'label label-ebus-primary'}>{item.uzytk_rola}</span>
                                                                <span style={{marginLeft: '5px', fontSize: '12px'}}>{item.opis}</span>
                                                            </Checkbox>
                                                        }
                                                    })
                                                }
                                            </div>
                                        </Col>
                                        :
                                        '' : ''
                            }
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12}>
                                <div className={'pull-right'}>
                                    <ButtonToolbar>
                                        <TopButtonCancel onClick={() => {
                                            this.props.handleClickAnuluj()
                                        }}/>
                                        <TopButtonSave onClick={this.onClickZapisz}/>
                                    </ButtonToolbar>
                                </div>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12}>
                                <ValidatorMessages messages={this.state.validatorMessages}/>
                            </Col>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/dostep/components/DostepForm.js